import { render, staticRenderFns } from "./IconSvgBzip.vue?vue&type=template&id=23606100&scoped=true&"
import script from "./IconSvgBzip.vue?vue&type=script&lang=js&"
export * from "./IconSvgBzip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23606100",
  null
  
)

export default component.exports